//Slider must cycle between items
document.addEventListener("DOMContentLoaded", function(){
  const slideContainer = document.getElementById("slide-container");
  const slideCount = document.querySelectorAll(".enlargeImageModal__desktop-slide").length;
  const modalImageArray = document.querySelectorAll(".enlargeImageModal__desktop--array-img");
  const thumbnailContainer = document.getElementById("enlargeImageModal-mobile-thumbnails");
  const thumbnails = document.querySelectorAll(".enlargeImageModal__mobile--array-list");
  const mainPageThumbnails = document.querySelectorAll(".product__array-img.mobile");
  let currentSlideIndex = 0;
  let slideWidth;
  let touchTime;

  //Clicking on large image must open modal with that specific image selected
  enlargeImageModal.addEventListener("shown.bs.modal", function(){
    const indexNumber = imgCoverDiv.getAttribute("img-index");
    currentSlideIndex = indexNumber;
    slideContainer.classList.add("no-transition");
    updateSlidePosition();
    setTimeout(function(){
      slideContainer.classList.remove("no-transition");
      slideContainer.classList.remove("hidden");
    }, 50);

    //Side Image Array on Modal must work with slider
    modalImageArray.forEach((smallModalImage, modalIndex) => {
      smallModalImage.addEventListener("click", function(){
        //Remove the 'highlight' class from all small images
        modalImageArray.forEach((smallModalImage) => {
          smallModalImage.classList.remove("highlight");
        });

        //Add the 'highlight' class to the clicked small image
        smallModalImage.classList.add("highlight");

        //Slide to corresponding image slide
        slideWidth = document.querySelector(".enlargeImageModal__desktop-slide").clientWidth;
        slideContainer.style.transform = "translateX(" + (-modalIndex * slideWidth) + "px)";

        //Update the array of thumbnails
        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          thumbnail.classList.remove("thumbnailSelected");
          if(thumbnailIndex == modalIndex){
            thumbnail.classList.add("thumbnailSelected");
          }
        });

        //Update the currentSlideIndex Variable
        currentSlideIndex = modalIndex;

        //Update the main page array of small images
        smallImages.forEach((smallImage, index) => {
          if(index == modalIndex){
            const mainImageSrc = smallImage.getAttribute("src");
            largeImage.setAttribute("src", mainImageSrc);
            imgCoverDiv.setAttribute("img-index", index);
            smallImage.classList.add("highlight");
          } else {
            smallImage.classList.remove("highlight");
          }
        });

        //Update the main page array of mobile thumbnails
        mainPageThumbnails.forEach((mainPageThumbnail, mainPageThumbnailIndex) => {
          if(mainPageThumbnailIndex == modalIndex){
            mainPageThumbnail.classList.add("highlight");
          } else {
            mainPageThumbnail.classList.remove("highlight");
          }
        });
      });

      //Set the 'highlight' class on the image chosen by default
      if(modalIndex == indexNumber){
        smallModalImage.classList.add("highlight");
      }
    });

    //Mobile image thumbnails must work with slider
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      function thumbClickStart(){
        touchTime = new Date().getTime();
      }

      function thumbClickEnd(){
        const touchDuration = new Date().getTime() - touchTime;
        if(touchDuration < 200){
          //Remove the 'thumbnailSelected' class from all thumbnails
          thumbnails.forEach((thumbnail) => {
            thumbnail.classList.remove("thumbnailSelected");
          });

          //Add the 'thumbnailSelected' class to the clicked thumbnail
          thumbnail.classList.add("thumbnailSelected");

          //Slide to corresponding image slide
          slideWidth = document.querySelector(".enlargeImageModal__desktop-slide").clientWidth;
          slideContainer.style.transform = "translateX(" + (-thumbnailIndex * slideWidth) + "px)";

          //Update the array of small images on the modal
          const smallModalImages = document.querySelectorAll(".enlargeImageModal__desktop--array-img");
          smallModalImages.forEach((smallModalImage, index) => {
            smallModalImage.classList.remove("highlight");
            if(index == thumbnailIndex){
              smallModalImage.classList.add("highlight");
            }
          });

          //Update the currentSlideIndex Variable
          currentSlideIndex = thumbnailIndex;

          //Update the main page array of small images
          smallImages.forEach((smallImage, index) => {
            if(index == thumbnailIndex){
              const mainImageSrc = smallImage.getAttribute("src");
              largeImage.setAttribute("src", mainImageSrc);
              imgCoverDiv.setAttribute("img-index", index);
              smallImage.classList.add("highlight");
            } else {
              smallImage.classList.remove("highlight");
            }
          });

          //Update the main page array of thumbnails
          mainPageThumbnails.forEach((mainPageThumbnail, mainPageThumbnailIndex) => {
            if(mainPageThumbnailIndex == thumbnailIndex){
              mainPageThumbnail.classList.add("highlight");
            } else {
              mainPageThumbnail.classList.remove("highlight");
            }
          });

          scrollToView(thumbnail);
        }
      }

      thumbnail.addEventListener("mousedown", thumbClickStart);
      thumbnail.addEventListener("touchstart", thumbClickStart);
      thumbnail.addEventListener("mouseup", thumbClickEnd);
      thumbnail.addEventListener("touchend", thumbClickEnd);

      //If the thumbnail index number matches the slide index number. Remove the 'thumbnailSelected' class for all and add it only to that specific thumbnail
      if(thumbnailIndex == indexNumber){
        thumbnails.forEach(i => i.classList.remove('thumbnailSelected'));
        thumbnail.classList.add("thumbnailSelected");
        scrollToView(thumbnail);
      }
    });
  });

  //Clicking on Modal Close Button must hide the slide container
  document.getElementById("modalCloseBtn").addEventListener("click", function(){
    slideContainer.classList.add("hidden");
    //Remove the 'highlight' class from all small images
    modalImageArray.forEach((smallModalImage) => {
      smallModalImage.classList.remove("highlight");
    });
    //Remove the 'thumbnailSelected class from all thumbnails'
    thumbnails.forEach((thumbnail) => {
      thumbnail.classList.remove("thumbnailSelected");
    });
  });

  window.showNextSlide = function(){
    currentSlideIndex++;
    if (currentSlideIndex >= slideCount) {
      currentSlideIndex = 0;
    }

    //Update the modal array of small images
    modalImageArray.forEach((smallModalImage, modalIndex) => {
      if(modalIndex == currentSlideIndex){
        smallModalImage.classList.add("highlight");
      } else {
        smallModalImage.classList.remove("highlight");
      }
    });

    //Update the mobile thumbnails
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      if(thumbnailIndex == currentSlideIndex){
        thumbnail.classList.add("thumbnailSelected");
        scrollToView(thumbnail);
      } else {
        thumbnail.classList.remove("thumbnailSelected");
      }
    });

    //Update the main page array of small images
    smallImages.forEach((smallImage, index) => {
      if(index == currentSlideIndex){
        const nextImageSrc = smallImage.getAttribute("src");
        largeImage.setAttribute("src", nextImageSrc);
        imgCoverDiv.setAttribute("img-index", index);
        smallImage.classList.add("highlight");
      } else {
        smallImage.classList.remove("highlight");
      }
    });

    //Update the main page array of thumbnails
    mainPageThumbnails.forEach((mainPageThumbnail, mainPageThumbnailIndex) => {
      if(mainPageThumbnailIndex == currentSlideIndex){
        mainPageThumbnail.classList.add("highlight");
      } else {
        mainPageThumbnail.classList.remove("highlight");
      }
    });

    //Update main slide position
    updateSlidePosition();
  };

  window.showPreviousSlide = function() {
    currentSlideIndex--;
    if (currentSlideIndex < 0) {
      currentSlideIndex = slideCount - 1;
    }

    //Update the modal array of small images
    modalImageArray.forEach((smallModalImage, modalIndex) => {
      if(modalIndex == currentSlideIndex){
        smallModalImage.classList.add("highlight");
      } else {
        smallModalImage.classList.remove("highlight");
      }
    });

    //Update the mobile thumbnails
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      if(thumbnailIndex == currentSlideIndex){
        thumbnail.classList.add("thumbnailSelected");
        scrollToView(thumbnail);
      } else {
        thumbnail.classList.remove("thumbnailSelected");
      }
    });

    //Update the main page array of small images
    smallImages.forEach((smallImage, index) => {
      if(index == currentSlideIndex){
        const prevImageSrc = smallImage.getAttribute("src");
        largeImage.setAttribute("src", prevImageSrc);
        imgCoverDiv.setAttribute("img-index", index);
        smallImage.classList.add("highlight");
      } else {
        smallImage.classList.remove("highlight");
      }
    });

    //Update the main page array of thumbnails
    mainPageThumbnails.forEach((mainPageThumbnail, mainPageThumbnailIndex) => {
      if(mainPageThumbnailIndex == currentSlideIndex){
        mainPageThumbnail.classList.add("highlight");
      } else {
        mainPageThumbnail.classList.remove("highlight");
      }
    });

    //Update main slide position
    updateSlidePosition();
  };

  function updateSlidePosition() {
    slideWidth = document.querySelector(".enlargeImageModal__desktop-slide").clientWidth;
    slideContainer.style.transform = "translateX(" + (-currentSlideIndex * slideWidth) + "px)";
  };

  //Scroll to thumbnail function
  const thumbnailMargin = 20; // 20px margin
  let observer;
  let thumbnailIsDragging = false;
  let thumbnailStartX;
  let thumbnailScrollLeft;
  let dragTimeout;
  let timer;

  function setupObserver(){
    if (observer) {
      observer.disconnect();
    }

    const options = {
      root: thumbnailContainer,
      threshold: 1.0
    };

    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              entry.target.classList.remove('partially-hidden');
          } else {
              entry.target.classList.add('partially-hidden');
          }
      });
    }, options);

    thumbnails.forEach(thumbnail => {
      observer.observe(thumbnail);
    });
  }

  function scrollToView(thumbnail){
    const thumbnailContainerRect = thumbnailContainer.getBoundingClientRect();
    const thumbnailRect = thumbnail.getBoundingClientRect();

    //Calculate the amount to scroll
    const thumbnailContainerScrollLeft = thumbnailContainer.scrollLeft;
    const thumbnailOffsetLeft = thumbnailRect.left + thumbnailContainerScrollLeft - thumbnailContainerRect.left;

    if(thumbnailRect.left < thumbnailContainerRect.left + thumbnailMargin){
      // Item is too far left
      thumbnailContainer.scrollTo({
          left: thumbnailOffsetLeft - thumbnailMargin,
          behavior: 'smooth'
      });
    } else if (thumbnailRect.right > thumbnailContainerRect.right - thumbnailMargin){
      // Item is too far right
      thumbnailContainer.scrollTo({
          left: thumbnailOffsetLeft - thumbnailContainerRect.width + thumbnailRect.width + thumbnailMargin,
          behavior: 'smooth'
      });
    }
  }

  window.addEventListener("resize", function(){
    const thumbnailSelected = document.querySelector('.enlargeImageModal__mobile--array-list.thumbnailSelected');
    if (thumbnailSelected) {
        scrollToView(thumbnailSelected);
    }
    setupObserver();
  });

  function startDrag(e){
    thumbnailIsDragging = true;
    thumbnailStartX = e.type.includes("mouse") ? e.pageX - thumbnailContainer.offsetLeft : e.touches[0].pageX - thumbnailContainer.offsetLeft;
    thumbnailScrollLeft = thumbnailContainer.scrollLeft;
    thumbnailContainer.style.cursor = "grabbing";
    timer = setTimeout(() => {
      thumbnails.forEach((thumbnail) => {
        thumbnail.style.cursor = "grabbing";
      });
    }, 100);
  }

  function dragList(e){
    if (!thumbnailIsDragging) return;
    e.preventDefault();
    const x = e.type.includes("mouse") ? e.pageX - thumbnailContainer.offsetLeft : e.touches[0].pageX - thumbnailContainer.offsetLeft;
    const walk = (x - thumbnailStartX) * 2; // 2 is the scroll speed factor
    thumbnailContainer.scrollLeft = thumbnailScrollLeft - walk;
  }

  function endDrag(){
    clearTimeout(dragTimeout);
    thumbnailIsDragging = false;
    thumbnailContainer.style.cursor = "default";
    clearTimeout(timer);
    thumbnails.forEach((thumbnail) => {
      thumbnail.style.cursor = "pointer";
    });
  }

  thumbnailContainer.addEventListener("mousedown", startDrag);
  thumbnailContainer.addEventListener("touchstart", startDrag);
  thumbnailContainer.addEventListener("mousemove", dragList);
  thumbnailContainer.addEventListener("touchmove", dragList);  
  thumbnailContainer.addEventListener("mouseleave", endDrag);
  thumbnailContainer.addEventListener("mouseup", endDrag);
  thumbnailContainer.addEventListener("touchend", endDrag);

  setupObserver();
  //End Scroll to thumbnail function

  //Check when viewport gets resized and translate slides to ensure image remains in middle
  window.addEventListener("resize", function(){
    slideContainer.classList.add("no-transition");
    slideWidth = document.querySelector(".enlargeImageModal__desktop-slide").clientWidth;
    slideContainer.style.transform = "translateX(" + (-currentSlideIndex * slideWidth) + "px)";
    setTimeout(function(){
      slideContainer.classList.remove("no-transition");
    }, 100);
  });
});

//Make Images in Slide Zoom-able and Draggable
document.querySelectorAll(".enlargeImageModal__desktop-slide").forEach(container => {
  const img = container.querySelector(".enlargeImageModal__slide-img");
  let isDragging = false;
  let startX, startY, initialX, initialY;
  let clickTime = 0;
  let minimizedLeft, minimizedTop;
  let originalLeft, originalTop;

  function imageDragStart(e){
    if(e.button === 0 || e.type.includes("touch")){
      if(img.classList.contains("maximized")){
        clickTime = new Date().getTime();
        isDragging = true;
        startX = e.type.includes("mouse") ? e.clientX : e.touches[0].pageX;
        startY = e.type.includes("mouse") ? e.clientY : e.touches[0].pageY;
        const computedStyle = window.getComputedStyle(img);
        initialX = parseInt(computedStyle.left, 10) || 0;
        initialY = parseInt(computedStyle.top, 10) || 0;
      } else {
        minimizedLeft = img.style.left;
        minimizedTop = img.style.top;
        img.classList.add("transition");
        img.classList.remove("minimized");
        img.classList.add("maximized");
        //Remove transition class after transition ends
        img.addEventListener("transitionend", function(){
          img.classList.remove("transition");
        }, { once: true });
        if (originalLeft === undefined && originalTop === undefined) {
          originalLeft = img.style.left;
          originalTop = img.style.top;
        } else {
          img.style.left = originalLeft;
          img.style.top = originalTop;
        }
      }
    }
  }

  function imageDrag(e){
    if (isDragging) {
      const dx = e.type.includes("mouse") ? e.clientX - startX : e.touches[0].pageX - startX;
      const dy = e.type.includes("mouse") ? e.clientY - startY : e.touches[0].pageY - startY;
      img.style.left = `${initialX + dx}px`;
      img.style.top = `${initialY + dy}px`;
    }
  }

  function imageDragEnd(){
    const clickDuration = new Date().getTime() - clickTime;
    if(clickDuration < 200 && img.classList.contains("maximized")){
      isDragging = false;
      img.classList.add("transition");
      img.classList.remove("maximized");
      img.classList.add("minimized");
      img.style.left = originalLeft;
      img.style.top = originalTop;
    } else {
      isDragging = false;
    }
  }

  img.addEventListener("mousedown", imageDragStart);
  img.addEventListener("touchstart", imageDragStart);
  img.addEventListener("mousemove", imageDrag);
  img.addEventListener("touchmove", imageDrag);
  img.addEventListener("mouseup", imageDragEnd);
  img.addEventListener("touchend", function(e){
    e.preventDefault();
    imageDragEnd();
  });

  //Reset Image Position when Next, Prev, Small Image Array or Close Modal Buttons are clicked on
  document.getElementById("enlargeImageModal__btn--slider-left").addEventListener("click", function(){
    isDragging = false;
    img.classList.add("transition");
    img.classList.remove("maximized");
    img.classList.add("minimized");
    img.style.left = originalLeft;
    img.style.top = originalTop;
  });
  document.getElementById("enlargeImageModal__btn--slider-right").addEventListener("click", function(){
    isDragging = false;
    img.classList.add("transition");
    img.classList.remove("maximized");
    img.classList.add("minimized");
    img.style.left = originalLeft;
    img.style.top = originalTop;
  });
  document.querySelectorAll(".enlargeImageModal__desktop--array-img").forEach((smallModalImage) => {
    smallModalImage.addEventListener("click", function(){
      isDragging = false;
      img.classList.add("transition");
      img.classList.remove("maximized");
      img.classList.add("minimized");
      img.style.left = originalLeft;
      img.style.top = originalTop;
    });
  });
  document.querySelectorAll(".enlargeImageModal__mobile--array-img").forEach((thumbnail) => {
    thumbnail.addEventListener("click", function(){
      isDragging = false;
      img.classList.add("transition");
      img.classList.remove("maximized");
      img.classList.add("minimized");
      img.style.left = originalLeft;
      img.style.top = originalTop;
    });
  });
  document.getElementById("modalCloseBtn").addEventListener("click", function(){
    isDragging = false;
    img.classList.add("transition");
    img.classList.remove("maximized");
    img.classList.add("minimized");
    img.style.left = originalLeft;
    img.style.top = originalTop;
  });
});